import React from "react";
import CollectionSearchDropdown from "./CollectionSearchDropdown";

export default function AlbumSearchDropdown({ onSelect, ...props }) {
  return (
    <CollectionSearchDropdown
      {...props}
      types="album"
      onSelect={(result) => onSelect(result.item)}
    />
  );
}
